import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "../modals/DialogTitle";
import Form from "./ConnectForm";

export default function ConnectAmazonDialog(props) {
  const { open, handleClose, lines = null } = props;

  return (
    <Dialog open={open} maxWidth="md" onClose={handleClose}>
      <DialogTitle title="Connect Amazon Seller Account" />
      <Form handleClose={handleClose} lines={lines} />
    </Dialog>
  );
}
